let matrixClient = null

export const getMatrixClient = () => matrixClient

export const setMatrixClient = (client) => {
  matrixClient = client
}
